export function cleanInvitationUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete("invitation_code");
  url.searchParams.delete("company_name");
  window.history.replaceState({}, document.title, url.pathname);
}
